export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export type AcceptAnonymousInviteFacilityInput = {
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AcceptAnonymousInviteHomeInput = {
  countryCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AcceptAnonymousInviteResponse = {
  __typename?: 'AcceptAnonymousInviteResponse';
  status: Scalars['String']['output'];
};

export enum AccessLevel {
  Admin = 'ADMIN',
  None = 'NONE',
  Owner = 'OWNER'
}

export type AddressDetails = {
  __typename?: 'AddressDetails';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressDetailsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Admin = {
  __typename?: 'Admin';
  acceptedPrivacyConditions?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sendSms?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Admin>;
};


export type AdminUpdateArgs = {
  input: UpdateAdminInput;
};

export type AdminAccessInput = {
  accessLevel?: InputMaybe<AccessLevel>;
  id: Scalars['ID']['input'];
};

export type AdminInput = {
  acceptedPrivacyConditions: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  inviteToken: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type AdminInvite = {
  __typename?: 'AdminInvite';
  email: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['String']['output']>;
};

export type AdminInviteInput = {
  email: Scalars['String']['input'];
  organizations: Array<InputMaybe<AdminAccessInput>>;
};

export enum AlertAvailability {
  Always = 'ALWAYS',
  Officehrs = 'OFFICEHRS',
  Unavailable = 'UNAVAILABLE'
}

export type AlertGroupMember = {
  __typename?: 'AlertGroupMember';
  availability: AlertAvailability;
  phone: Scalars['String']['output'];
  sendSms: Scalars['Boolean']['output'];
};

export type AlertGroupMemberInput = {
  availability: AlertAvailability;
  phone: Scalars['String']['input'];
  sendSms: Scalars['Boolean']['input'];
};

export type AlterSubscriptionInput = {
  connectorIds: Array<InputMaybe<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
};

export type AnonymousInvite = {
  __typename?: 'AnonymousInvite';
  addressDetails?: Maybe<AddressDetails>;
  numOfConnectors?: Maybe<Scalars['Int']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type AuthData = {
  __typename?: 'AuthData';
  status: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type AuthInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AuthResponseData = {
  __typename?: 'AuthResponseData';
  status: Scalars['Float']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type AutomaticReport = {
  __typename?: 'AutomaticReport';
  chargeSystemIds?: Maybe<Array<Scalars['ID']['output']>>;
  emailRecipients?: Maybe<Array<Scalars['String']['output']>>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fileFormat?: Maybe<FileFormat>;
  frequency?: Maybe<AutomaticReportFrequency>;
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  reportTypes?: Maybe<Array<AutomaticReportType>>;
};

export enum AutomaticReportFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

export type AutomaticReportInput = {
  chargeSystemIds: Array<Scalars['ID']['input']>;
  emailRecipients: Array<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  fileFormat?: InputMaybe<FileFormat>;
  frequency: AutomaticReportFrequency;
  language?: InputMaybe<Scalars['String']['input']>;
  reportTypes: Array<AutomaticReportType>;
};

export type AutomaticReportSettings = {
  __typename?: 'AutomaticReportSettings';
  automaticReportConfigs: Array<AutomaticReport>;
};

export enum AutomaticReportType {
  Imd = 'IMD',
  Payout = 'PAYOUT',
  Session = 'SESSION',
  UsageCharger = 'USAGE_CHARGER',
  UsageRfid = 'USAGE_RFID',
  UsageUser = 'USAGE_USER'
}

export type AutomaticReportUpdateInput = {
  chargeSystemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fileFormat?: InputMaybe<FileFormat>;
  frequency?: InputMaybe<AutomaticReportFrequency>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  reportTypes?: InputMaybe<Array<AutomaticReportType>>;
};

export type Billing = {
  __typename?: 'Billing';
  cycle: Scalars['String']['output'];
  date?: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['String']['output'];
};

export enum BillingInterval {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiYearly = 'SEMI_YEARLY',
  Yearly = 'YEARLY'
}

export enum BillingMethod {
  Card = 'CARD',
  Invoice = 'INVOICE'
}

export enum BillingMethods {
  Card = 'CARD',
  Imd = 'IMD',
  Invoice = 'INVOICE'
}

export enum BillingPeriod {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiYearly = 'SEMI_YEARLY',
  Yearly = 'YEARLY'
}

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ChargePoint = {
  __typename?: 'ChargePoint';
  chargePointModel?: Maybe<Scalars['String']['output']>;
  chargePointSerialNumber?: Maybe<Scalars['String']['output']>;
  chargePointVendor?: Maybe<Scalars['String']['output']>;
  chargeSystemId: Scalars['String']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loadBalancingActive?: Maybe<Scalars['Boolean']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  reset: ChargePointStatus;
};


export type ChargePointResetArgs = {
  input: ResetType;
};

export enum ChargePointResponseCode {
  Accepted = 'ACCEPTED',
  Failure = 'FAILURE',
  NotSupported = 'NOT_SUPPORTED',
  Pending = 'PENDING',
  RebootRequired = 'REBOOT_REQUIRED',
  Rejected = 'REJECTED',
  Unreachable = 'UNREACHABLE'
}

export type ChargePointStatus = {
  __typename?: 'ChargePointStatus';
  responseCode?: Maybe<ChargePointResponseCode>;
  status: Scalars['Boolean']['output'];
};

export type ChargePointsStatus = {
  __typename?: 'ChargePointsStatus';
  responseCodes: Array<Maybe<ChargePointResponseCode>>;
  status: Scalars['Boolean']['output'];
};

export type ChargeSystem = {
  __typename?: 'ChargeSystem';
  P3liveConsumptionEnabled?: Maybe<Scalars['Boolean']['output']>;
  addAlertGroup?: Maybe<Status>;
  addGroup?: Maybe<Group>;
  addressDetails?: Maybe<AddressDetails>;
  alertGroup?: Maybe<Array<AlertGroupMember>>;
  alterAccessKeys?: Maybe<Status>;
  alterAccessUsers?: Maybe<Status>;
  category?: Maybe<Scalars['String']['output']>;
  configurationStatus?: Maybe<ConfigurationStatus>;
  connectConnectorsToGroup?: Maybe<ChargePointsStatus>;
  connectors?: Maybe<Array<Connector>>;
  deleteGroup?: Maybe<Status>;
  deleteRfidKey?: Maybe<Status>;
  deleteUsers?: Maybe<Status>;
  extApiClientP3?: Maybe<Scalars['String']['output']>;
  fixedPerUserFee?: Maybe<Scalars['Float']['output']>;
  getInvoices?: Maybe<GetInvoicesPayload>;
  group?: Maybe<Group>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID']['output'];
  imdKwhPrice?: Maybe<Scalars['Float']['output']>;
  inviteUsers?: Maybe<PostResponseWithBody>;
  invitedUsers?: Maybe<Array<UserInvite>>;
  invoice?: Maybe<InvoiceDetails>;
  invoiceReferencesByUserIds?: Maybe<InvoiceReferencesByUserIds>;
  invoicesOutstandingAmount?: Maybe<OutstandingAmountPayload>;
  invoicingActivated?: Maybe<Scalars['Boolean']['output']>;
  invoicingInfo?: Maybe<InvoicingInfo>;
  name?: Maybe<Scalars['String']['output']>;
  resendInviteUsers?: Maybe<Status>;
  revokeInvitedUsers?: Maybe<Status>;
  setDefault?: Maybe<ChargePointsStatus>;
  setImdKwhPrice?: Maybe<Status>;
  setUseImd?: Maybe<Status>;
  subCategory?: Maybe<Scalars['String']['output']>;
  toggleShowConsumption?: Maybe<ToggleConsumptionPayload>;
  update?: Maybe<ChargeSystem>;
  updateConnector?: Maybe<Status>;
  updateConnectors?: Maybe<ChargePointsStatus>;
  updateGroups?: Maybe<ChargePointsStatus>;
  updateInvoicingInfo?: Maybe<Status>;
  useImd?: Maybe<Scalars['Boolean']['output']>;
  userDiscount?: Maybe<Status>;
  userPaymentType?: Maybe<Status>;
  users?: Maybe<Array<User>>;
};


export type ChargeSystemAddAlertGroupArgs = {
  input: Array<AlertGroupMemberInput>;
};


export type ChargeSystemAddGroupArgs = {
  input: GroupInput;
};


export type ChargeSystemAlterAccessKeysArgs = {
  input: Array<UserAlterAccessInput>;
};


export type ChargeSystemAlterAccessUsersArgs = {
  input: Array<UserAlterAccessInput>;
};


export type ChargeSystemConnectConnectorsToGroupArgs = {
  input?: InputMaybe<Array<InputMaybe<ConnectConnectorsToGroupInput>>>;
};


export type ChargeSystemConnectorsArgs = {
  filter?: InputMaybe<ConnectorFilter>;
};


export type ChargeSystemDeleteGroupArgs = {
  input: DeleteGroupInput;
};


export type ChargeSystemDeleteRfidKeyArgs = {
  input: DeleteRfidKeyInput;
};


export type ChargeSystemDeleteUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<UserInput>>>;
};


export type ChargeSystemGetInvoicesArgs = {
  input: GetInvoicesInput;
};


export type ChargeSystemGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ChargeSystemInviteUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<UserInviteInput>>>;
};


export type ChargeSystemInvoiceArgs = {
  input: GetInvoiceInput;
};


export type ChargeSystemResendInviteUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<UserInviteInput>>>;
};


export type ChargeSystemRevokeInvitedUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<UserInviteInput>>>;
};


export type ChargeSystemSetImdKwhPriceArgs = {
  input: SetImdKwhPriceInput;
};


export type ChargeSystemSetUseImdArgs = {
  input: SetUseImdInput;
};


export type ChargeSystemToggleShowConsumptionArgs = {
  input: ToggleConsumptionInput;
};


export type ChargeSystemUpdateArgs = {
  input: ChargeSystemUpdateInput;
};


export type ChargeSystemUpdateConnectorArgs = {
  input?: InputMaybe<ConnectorInput>;
};


export type ChargeSystemUpdateConnectorsArgs = {
  input?: InputMaybe<Array<InputMaybe<ConnectorUpdateInput>>>;
};


export type ChargeSystemUpdateGroupsArgs = {
  input: Array<GroupUpdateInput>;
};


export type ChargeSystemUpdateInvoicingInfoArgs = {
  input: InvoicingInfoInput;
};


export type ChargeSystemUserDiscountArgs = {
  input: UserDiscountInput;
};


export type ChargeSystemUserPaymentTypeArgs = {
  input: UserPaymentTypeInput;
};

export type ChargeSystemCategory = {
  __typename?: 'ChargeSystemCategory';
  id: Scalars['String']['output'];
  item: Array<Scalars['String']['output']>;
};

export type ChargeSystemInput = {
  address: Scalars['String']['input'];
  businessType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Type;
};

export type ChargeSystemUpdateInput = {
  addressDetails?: InputMaybe<AddressDetailsInput>;
  broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  configurationStatus?: InputMaybe<ConfigurationStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  privateCharging?: InputMaybe<ChargingTypeState>;
  privateChargingSettings?: InputMaybe<PrivateChargingSettingsUpdateInput>;
  publicCharging?: InputMaybe<ChargingTypeState>;
  publicChargingSettings?: InputMaybe<PublicChargingSettingsUpdateInput>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  visibleInApps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChargerUsage = {
  __typename?: 'ChargerUsage';
  alias: Scalars['String']['output'];
  chargingSessions: UnitAmount;
  displayName?: Maybe<Scalars['String']['output']>;
  energyConsumption: UnitAmount;
  occupiedTime: UnitAmount;
  revenue: UnitAmount;
};

export enum ChargingTypeState {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  SetupRequired = 'SETUP_REQUIRED'
}

export type ConfigurationKeys = {
  __typename?: 'ConfigurationKeys';
  keys?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export enum ConfigurationStatus {
  Completed = 'COMPLETED',
  RestrictedByTermsAndConditions = 'RESTRICTED_BY_TERMS_AND_CONDITIONS',
  SetupRequired = 'SETUP_REQUIRED',
  TermsAndConditionsRequired = 'TERMS_AND_CONDITIONS_REQUIRED'
}

export type ConnectConnectorsToGroupInput = {
  connectors: Array<InputMaybe<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
};

export type Connector = {
  __typename?: 'Connector';
  alias?: Maybe<Scalars['String']['output']>;
  broadcast?: Maybe<Scalars['Boolean']['output']>;
  chargePointId?: Maybe<Scalars['ID']['output']>;
  connectorNumber?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  energyMeterAvailable?: Maybe<EnergyMeterAvailable>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorInfo?: Maybe<Scalars['String']['output']>;
  eventLogUrl?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  id: Scalars['ID']['output'];
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  meterValue?: Maybe<Scalars['Float']['output']>;
  operationalData?: Maybe<OperationalData>;
  power?: Maybe<Scalars['Float']['output']>;
  sim?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ConnectorStatus>;
  statusLog?: Maybe<ConnectorStatusLog>;
  type?: Maybe<Scalars['String']['output']>;
  visibleInApps?: Maybe<Scalars['Boolean']['output']>;
};

export type ConnectorAction = {
  action: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type ConnectorActionResponse = {
  __typename?: 'ConnectorActionResponse';
  ok: Scalars['Boolean']['output'];
};

export enum ConnectorAvailability {
  Inoperative = 'INOPERATIVE',
  Operative = 'OPERATIVE'
}

export type ConnectorAvailabilityInput = {
  availability: ConnectorAvailability;
  chargeSystemId: Scalars['ID']['input'];
  connectorId: Scalars['ID']['input'];
};

export type ConnectorFilter = {
  alias: Scalars['String']['input'];
  connectorNumber: Scalars['Int']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorInput = {
  displayName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export enum ConnectorStatus {
  Available = 'AVAILABLE',
  Charging = 'CHARGING',
  EvConnected = 'EV_CONNECTED',
  FacilityFinishing = 'FACILITY_FINISHING',
  Faulted = 'FAULTED',
  Finishing = 'FINISHING',
  Idle = 'IDLE',
  Occupied = 'OCCUPIED',
  Preparing = 'PREPARING',
  Reserved = 'RESERVED',
  Restarting = 'RESTARTING',
  SuspendedEv = 'SUSPENDED_EV',
  SuspendedEvse = 'SUSPENDED_EVSE',
  Unavailable = 'UNAVAILABLE'
}

export type ConnectorStatusLog = {
  __typename?: 'ConnectorStatusLog';
  status: Scalars['Int']['output'];
  statusHistory: Array<Maybe<StatusObject>>;
};

export type ConnectorUpdateInput = {
  connectorIds: Array<InputMaybe<Scalars['ID']['input']>>;
  durationLimit?: InputMaybe<Scalars['Float']['input']>;
  idleFee?: InputMaybe<Scalars['Float']['input']>;
};

export type ConnectorsAvailabilityInput = {
  availability: ConnectorAvailability;
  chargeSystemId: Scalars['ID']['input'];
  connectorIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type Country = {
  __typename?: 'Country';
  billingMethods: Array<BillingMethods>;
  country: CountryDetails;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  openingHours?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CountryDetails = {
  __typename?: 'CountryDetails';
  countryCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  language: Scalars['String']['output'];
  vatB2BPercentage: Scalars['Float']['output'];
  vatB2CPercentage: Scalars['Float']['output'];
};

export type CreateRfidKeyInput = {
  chargeSystems: Array<InputMaybe<Scalars['String']['input']>>;
  connectors: Array<InputMaybe<Scalars['String']['input']>>;
  groups: Array<InputMaybe<Scalars['String']['input']>>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DateInput = {
  month: Scalars['String']['input'];
  year: Scalars['String']['input'];
};

export type DateOutput = {
  __typename?: 'DateOutput';
  month?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type DeleteGroupInput = {
  id: Scalars['String']['input'];
};

export type DeleteRfidKeyInput = {
  id: Scalars['String']['input'];
};

export type DeleteRfidKeyOnOrgInput = {
  id: Scalars['ID']['input'];
};

export type DownloadFileData = {
  __typename?: 'DownloadFileData';
  data: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
};

export type DownloadReportInput = {
  chargeSystemId?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['String']['input'];
  fileFormat: FileFormat;
  language: Scalars['String']['input'];
  reportType: DownloadReportType;
  startDate: Scalars['String']['input'];
};

export enum DownloadReportType {
  Charger = 'CHARGER',
  Imd = 'IMD',
  Payout = 'PAYOUT',
  Rfid = 'RFID',
  Session = 'SESSION',
  User = 'USER'
}

export enum EnergyMeterAvailable {
  Absent = 'ABSENT',
  Present = 'PRESENT',
  Unknown = 'UNKNOWN'
}

export enum FileFormat {
  Csv = 'CSV',
  Excel = 'EXCEL',
  Txt = 'TXT'
}

export type GetInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
};

export type GetInvoicesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  paginationToken?: InputMaybe<Scalars['String']['input']>;
  sortAscending?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetInvoicesPayload = {
  __typename?: 'GetInvoicesPayload';
  invoices: Array<Invoice>;
  paginationToken?: Maybe<Scalars['String']['output']>;
  totalItems: Scalars['Int']['output'];
};

export type GetRfidKeysInput = {
  csId?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};

export type Group = {
  __typename?: 'Group';
  broadcast?: Maybe<Scalars['Boolean']['output']>;
  ccGoActivated?: Maybe<Scalars['Boolean']['output']>;
  connectors?: Maybe<Array<Maybe<Connector>>>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  privateCharging?: Maybe<ChargingTypeState>;
  privateChargingSettings?: Maybe<PrivateChargingSettings>;
  publicCharging?: Maybe<ChargingTypeState>;
  publicChargingSettings?: Maybe<PublicChargingSettings>;
  responseCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  update?: Maybe<Group>;
  visibleInApps?: Maybe<Scalars['Boolean']['output']>;
};


export type GroupUpdateArgs = {
  input?: InputMaybe<GroupUpdateInput>;
};

export type GroupInput = {
  name: Scalars['String']['input'];
  privateCharging: ChargingTypeState;
  privateChargingSettings?: InputMaybe<PrivateChargingSettingsUpdateInput>;
  publicCharging: ChargingTypeState;
};

export enum GroupPriceModel {
  FlatRate = 'FLAT_RATE',
  Free = 'FREE',
  PowerUsage = 'POWER_USAGE',
  TimeUsage = 'TIME_USAGE'
}

export type GroupUpdateInput = {
  broadcast?: InputMaybe<Scalars['Boolean']['input']>;
  ccGoActivated?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  privateCharging?: InputMaybe<ChargingTypeState>;
  privateChargingSettings?: InputMaybe<PrivateChargingSettingsUpdateInput>;
  publicCharging?: InputMaybe<ChargingTypeState>;
  publicChargingSettings?: InputMaybe<PublicChargingSettingsUpdateInput>;
  visibleInApps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  isNewAdmin: Scalars['Boolean']['output'];
  valid: Scalars['Boolean']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  cost: Scalars['Float']['output'];
  createdDate: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  invoiceId: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalKwh: Scalars['Float']['output'];
};

export type InvoiceCustomerMetadata = {
  __typename?: 'InvoiceCustomerMetadata';
  billingAddress?: Maybe<AddressDetails>;
  orgEmail?: Maybe<Scalars['String']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  currency: Scalars['String']['output'];
  customerMetadata: InvoiceCustomerMetadata;
  dueDate?: Maybe<Scalars['String']['output']>;
  fee: Scalars['Float']['output'];
  invoiceId: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lineItems: Array<LineItem>;
  pdfDownloadUrl?: Maybe<Scalars['String']['output']>;
  platformFeePercentage: Scalars['Float']['output'];
  platformFees: Scalars['Float']['output'];
  sessionTotal: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  userMetadata: InvoiceUserMetadata;
  vatAmount: Scalars['Float']['output'];
  vatPercentage: Scalars['Float']['output'];
};

export type InvoiceReferencesByUserIds = {
  __typename?: 'InvoiceReferencesByUserIds';
  allReferenceByUserId: Scalars['JSON']['output'];
};

export type InvoiceUserMetadata = {
  __typename?: 'InvoiceUserMetadata';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type InvoicingChangeHistory = {
  __typename?: 'InvoicingChangeHistory';
  adminId?: Maybe<Scalars['String']['output']>;
  changeTime?: Maybe<Scalars['String']['output']>;
  invoicingActivated?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoicingInfo = {
  __typename?: 'InvoicingInfo';
  ChangeHistory?: Maybe<Array<Maybe<InvoicingChangeHistory>>>;
  adminId?: Maybe<Scalars['String']['output']>;
  fixedCostPerUser?: Maybe<Scalars['Float']['output']>;
  invoicingActivated?: Maybe<Scalars['Boolean']['output']>;
  modifiedTime?: Maybe<Scalars['String']['output']>;
};

export type InvoicingInfoInput = {
  fixedPerUserFee?: InputMaybe<Scalars['Float']['input']>;
  useInvoicing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LicenseTariff = {
  __typename?: 'LicenseTariff';
  fixedCost?: Maybe<Scalars['Float']['output']>;
  free?: Maybe<Scalars['Boolean']['output']>;
  freeParking?: Maybe<Scalars['Boolean']['output']>;
  pricePerHour?: Maybe<Scalars['Float']['output']>;
  pricePerKwh?: Maybe<Scalars['Float']['output']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  chargePoint: Scalars['String']['output'];
  chargedKwh: Scalars['Float']['output'];
  cost: Scalars['Float']['output'];
  duration: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  stopTime: Scalars['String']['output'];
  tariff: LicenseTariff;
};

export type LinearTariff = {
  __typename?: 'LinearTariff';
  fixedCost?: Maybe<Scalars['String']['output']>;
  hourDivisor?: Maybe<Scalars['String']['output']>;
  pricePerHour?: Maybe<Scalars['String']['output']>;
  pricePerKwh?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TariffType>;
};

export type LinearTariffInput = {
  fixedCost?: InputMaybe<Scalars['String']['input']>;
  hourDivisor?: InputMaybe<Scalars['String']['input']>;
  pricePerHour?: InputMaybe<Scalars['String']['input']>;
  pricePerKwh?: InputMaybe<Scalars['String']['input']>;
};

export type NewPasswordInput = {
  id: Scalars['String']['input'];
  newPass: Scalars['String']['input'];
  passwordToken: Scalars['String']['input'];
};

export type Ocpp = {
  __typename?: 'Ocpp';
  chargingState?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OperationalData = {
  __typename?: 'OperationalData';
  hbLastAlive?: Maybe<Scalars['String']['output']>;
  hbTimeout?: Maybe<Scalars['Boolean']['output']>;
  ocpp?: Maybe<Ocpp>;
  transactionMeterValue?: Maybe<Scalars['Float']['output']>;
  websocketOffline?: Maybe<Scalars['Boolean']['output']>;
  websocketOfflineStatusLastChanged?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  addChargeSystem?: Maybe<ChargeSystem>;
  admins?: Maybe<Array<Admin>>;
  annualSubscription?: Maybe<Scalars['Boolean']['output']>;
  automaticReport?: Maybe<AutomaticReport>;
  automaticReports?: Maybe<AutomaticReportSettings>;
  billingAddress?: Maybe<AddressDetails>;
  category?: Maybe<Scalars['String']['output']>;
  chargeSystems?: Maybe<Array<ChargeSystem>>;
  configurationStatus?: Maybe<ConfigurationStatus>;
  contactAddress?: Maybe<AddressDetails>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createAutomaticReport?: Maybe<AutomaticReport>;
  createRfidKey?: Maybe<Scalars['Boolean']['output']>;
  customerNr?: Maybe<Scalars['String']['output']>;
  customerReference?: Maybe<Scalars['String']['output']>;
  deleteAdmins?: Maybe<Status>;
  deleteAutomaticReport?: Maybe<Status>;
  deleteRfidKey?: Maybe<Scalars['Boolean']['output']>;
  downloadReport?: Maybe<DownloadFileData>;
  id?: Maybe<Scalars['ID']['output']>;
  inviteAdmins?: Maybe<Status>;
  invitedAdmins?: Maybe<Array<Maybe<AdminInvite>>>;
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orgNr?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  revokeInviteAdmins?: Maybe<Status>;
  stripeAccount?: Maybe<StripeAccount>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeStatus?: Maybe<StripeStatus>;
  subscription?: Maybe<Subscription>;
  subscriptionInvoicePdf?: Maybe<DownloadFileData>;
  subscriptionInvoices?: Maybe<SubscriptionInvoicesPayload>;
  updateAutomaticReport?: Maybe<AutomaticReport>;
  updateRfidKey?: Maybe<Scalars['Boolean']['output']>;
  vatLiable?: Maybe<Scalars['Boolean']['output']>;
  vatNr?: Maybe<Scalars['String']['output']>;
};


export type OrganizationAddChargeSystemArgs = {
  input: ChargeSystemInput;
};


export type OrganizationAutomaticReportArgs = {
  id: Scalars['ID']['input'];
};


export type OrganizationCreateAutomaticReportArgs = {
  input: AutomaticReportInput;
};


export type OrganizationCreateRfidKeyArgs = {
  input: CreateRfidKeyInput;
};


export type OrganizationDeleteAdminsArgs = {
  input: Array<AdminInviteInput>;
};


export type OrganizationDeleteAutomaticReportArgs = {
  id: Scalars['ID']['input'];
};


export type OrganizationDeleteRfidKeyArgs = {
  input: DeleteRfidKeyOnOrgInput;
};


export type OrganizationDownloadReportArgs = {
  input?: InputMaybe<DownloadReportInput>;
};


export type OrganizationInviteAdminsArgs = {
  input: Array<AdminInviteInput>;
};


export type OrganizationRevokeInviteAdminsArgs = {
  input: Array<AdminInviteInput>;
};


export type OrganizationSubscriptionInvoicePdfArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type OrganizationSubscriptionInvoicesArgs = {
  input: SubscriptionInvoicesInput;
};


export type OrganizationUpdateAutomaticReportArgs = {
  input: AutomaticReportUpdateInput;
};


export type OrganizationUpdateRfidKeyArgs = {
  input: UpdateRfidKeyInput;
};

export type OrganizationUpsertInput = {
  acceptedTermsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<AddressDetailsInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  configurationStatus?: InputMaybe<ConfigurationStatus>;
  contactAddress?: InputMaybe<AddressDetailsInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  customerReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgNr?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  stripeStatus?: InputMaybe<StripeStatus>;
  vatLiable?: InputMaybe<Scalars['Boolean']['input']>;
  vatNr?: InputMaybe<Scalars['String']['input']>;
};

export type OutstandingAmountPayload = {
  __typename?: 'OutstandingAmountPayload';
  currency: Scalars['String']['output'];
  deferred: Scalars['Float']['output'];
  open: Scalars['Float']['output'];
  overdue: Scalars['Float']['output'];
};

export type PasswordTokenValidInput = {
  id: Scalars['String']['input'];
  passwordToken: Scalars['String']['input'];
};

export type PostResponseWithBody = {
  __typename?: 'PostResponseWithBody';
  body?: Maybe<Array<ResponseBody>>;
  status: Scalars['Float']['output'];
};

export type PriceModel = {
  __typename?: 'PriceModel';
  description?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  userPay: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type PrivateChargingSettings = {
  __typename?: 'PrivateChargingSettings';
  accountNumber?: Maybe<Scalars['String']['output']>;
  billingInterval?: Maybe<BillingInterval>;
  billingMethod?: Maybe<BillingMethod>;
  priceModel?: Maybe<GroupPriceModel>;
  priceModelAmount?: Maybe<Scalars['String']['output']>;
  tariff?: Maybe<Tariff>;
};

export type PrivateChargingSettingsUpdateInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  billingInterval?: InputMaybe<BillingInterval>;
  billingMethod?: InputMaybe<BillingMethod>;
  priceModel?: InputMaybe<GroupPriceModel>;
  priceModelAmount?: InputMaybe<Scalars['String']['input']>;
  tariff?: InputMaybe<TariffInput>;
};

export type Product = {
  __typename?: 'Product';
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productPrices: Array<Maybe<ProductPrice>>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  billingPeriod?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceInclVAT?: Maybe<Scalars['Float']['output']>;
  productPriceId?: Maybe<Scalars['Int']['output']>;
};

export type ProductsInput = {
  organizationId: Scalars['ID']['input'];
};

export type ProgressiveTariff = {
  __typename?: 'ProgressiveTariff';
  fixedCost?: Maybe<Scalars['String']['output']>;
  hourDivisor?: Maybe<Scalars['String']['output']>;
  nrOfMinutes?: Maybe<Scalars['String']['output']>;
  pricePerHour?: Maybe<Scalars['String']['output']>;
  pricePerHour2?: Maybe<Scalars['String']['output']>;
  pricePerKwh?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TariffType>;
};

export type ProgressiveTariffInput = {
  fixedCost?: InputMaybe<Scalars['String']['input']>;
  hourDivisor?: InputMaybe<Scalars['String']['input']>;
  nrOfMinutes?: InputMaybe<Scalars['String']['input']>;
  pricePerHour?: InputMaybe<Scalars['String']['input']>;
  pricePerHour2?: InputMaybe<Scalars['String']['input']>;
  pricePerKwh?: InputMaybe<Scalars['String']['input']>;
};

export type PublicChargingSettings = {
  __typename?: 'PublicChargingSettings';
  accountNumber?: Maybe<Scalars['String']['output']>;
  durationLimit?: Maybe<Scalars['Float']['output']>;
  idleFee?: Maybe<Scalars['Float']['output']>;
  priceModel?: Maybe<GroupPriceModel>;
  priceModelAmount?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Array<Maybe<PublicChargingTime>>>;
  tariff?: Maybe<Tariff>;
};

export type PublicChargingSettingsUpdateInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  durationLimit?: InputMaybe<Scalars['Float']['input']>;
  idleFee?: InputMaybe<Scalars['Float']['input']>;
  priceModel?: InputMaybe<GroupPriceModel>;
  priceModelAmount?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Array<InputMaybe<PublicChargingTimeInput>>>;
  tariff?: InputMaybe<TariffInput>;
};

export type PublicChargingTime = {
  __typename?: 'PublicChargingTime';
  day: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  isAllDay?: Maybe<Scalars['Boolean']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type PublicChargingTimeInput = {
  day: Scalars['String']['input'];
  from?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export enum RangeType {
  End = 'end',
  Start = 'start'
}

export type RenameRfidKeyInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ReportDataOutput = {
  __typename?: 'ReportDataOutput';
  chargerUsage: Array<Maybe<ChargerUsage>>;
  userUsage: Array<Maybe<UserUsage>>;
  visitorRfidUsage: Array<Maybe<VisitorRfidUsage>>;
};

export type ReportInput = {
  chargeSystemIds: Array<InputMaybe<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  rangeType?: InputMaybe<RangeType>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type ReportOutput = {
  __typename?: 'ReportOutput';
  data: ReportDataOutput;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  perDay: ReportPerDayType;
  total: ReportType;
  trend: ReportType;
};

export type ReportPerDay = {
  __typename?: 'ReportPerDay';
  amount: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type ReportPerDayType = {
  __typename?: 'ReportPerDayType';
  energyConsumption?: Maybe<Array<Maybe<ReportPerDay>>>;
  revenue?: Maybe<Array<Maybe<ReportPerDay>>>;
};

export type ReportType = {
  __typename?: 'ReportType';
  chargingSessions?: Maybe<UnitAmount>;
  energyConsumption?: Maybe<UnitAmount>;
  occupationRate?: Maybe<UnitAmount>;
  occupiedTime?: Maybe<UnitAmount>;
  revenue?: Maybe<UnitAmount>;
};

export type ResetPasswordInput = {
  email: Scalars['String']['input'];
};

export enum ResetType {
  Hard = 'HARD',
  Soft = 'SOFT'
}

export type ResponseBody = {
  __typename?: 'ResponseBody';
  data: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Rfid = {
  __typename?: 'Rfid';
  chargeSystems: Array<Maybe<RfidAccess>>;
  connectors: Array<Maybe<RfidAccess>>;
  groups: Array<Maybe<RfidAccess>>;
  id: Scalars['ID']['output'];
  keys: Array<Maybe<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
};

export type RfidAccess = {
  __typename?: 'RfidAccess';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Root = {
  __typename?: 'Root';
  acceptAnonymousInviteFacility: AcceptAnonymousInviteResponse;
  acceptAnonymousInviteHome: AcceptAnonymousInviteResponse;
  acceptSubscription: Status;
  addAdmin: AuthData;
  admin?: Maybe<Admin>;
  admins: Array<Maybe<Admin>>;
  alterSubscription: Status;
  anonymousInvite: AnonymousInvite;
  authenticated: Status;
  changePassword: AuthResponseData;
  chargePoint?: Maybe<ChargePoint>;
  chargeSystem?: Maybe<ChargeSystem>;
  chargeSystemCategories: Array<Maybe<ChargeSystemCategory>>;
  chargeSystems: Array<Maybe<ChargeSystem>>;
  connector?: Maybe<Connector>;
  connectorAction: ConnectorActionResponse;
  countries: Array<Maybe<Country>>;
  createStripeAccount?: Maybe<Scalars['String']['output']>;
  generateStripeAccountLink?: Maybe<Scalars['String']['output']>;
  generateStripeAccountUpdateLink?: Maybe<Scalars['String']['output']>;
  getPasswordTokenValid: AuthResponseData;
  group?: Maybe<Group>;
  groups: Array<Maybe<Group>>;
  hello?: Maybe<Scalars['String']['output']>;
  invitation: Invitation;
  login: AuthData;
  newPassword: AuthResponseData;
  organization?: Maybe<Organization>;
  organizationCategories: Array<Maybe<Scalars['String']['output']>>;
  organizations: Array<Maybe<Organization>>;
  products: Array<Maybe<Product>>;
  readChargePointConfiguration?: Maybe<ConfigurationKeys>;
  renameRfidKey?: Maybe<Scalars['Boolean']['output']>;
  reports: Array<Maybe<ReportOutput>>;
  reportsAvailable: DateOutput;
  resetPassword: AuthResponseData;
  rfidKeys?: Maybe<Array<Rfid>>;
  setInvoiceReference?: Maybe<Status>;
  updateChargeSystem: ChargeSystem;
  updateConnectorsAvailability: Status;
  upsertOrganization: Organization;
};


export type RootAcceptAnonymousInviteFacilityArgs = {
  input: AcceptAnonymousInviteFacilityInput;
};


export type RootAcceptAnonymousInviteHomeArgs = {
  input: AcceptAnonymousInviteHomeInput;
};


export type RootAcceptSubscriptionArgs = {
  organizationId: Scalars['ID']['input'];
};


export type RootAddAdminArgs = {
  input: AdminInput;
};


export type RootAdminArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type RootAdminsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootAlterSubscriptionArgs = {
  input: AlterSubscriptionInput;
};


export type RootAnonymousInviteArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type RootChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type RootChargePointArgs = {
  chargePointId?: InputMaybe<Scalars['ID']['input']>;
  chargeSystemId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootChargeSystemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootChargeSystemCategoriesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootChargeSystemsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootConnectorArgs = {
  chargeSystemId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootConnectorActionArgs = {
  input: ConnectorAction;
};


export type RootCountriesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootCreateStripeAccountArgs = {
  onboarding: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type RootGenerateStripeAccountLinkArgs = {
  onboarding: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type RootGenerateStripeAccountUpdateLinkArgs = {
  organizationId: Scalars['ID']['input'];
};


export type RootGetPasswordTokenValidArgs = {
  input: PasswordTokenValidInput;
};


export type RootGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootGroupsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootInvitationArgs = {
  token: Scalars['String']['input'];
};


export type RootLoginArgs = {
  input: AuthInput;
};


export type RootNewPasswordArgs = {
  input: NewPasswordInput;
};


export type RootOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootOrganizationCategoriesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootOrganizationsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootProductsArgs = {
  input?: InputMaybe<ProductsInput>;
};


export type RootReadChargePointConfigurationArgs = {
  chargePointId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootRenameRfidKeyArgs = {
  input: RenameRfidKeyInput;
};


export type RootReportsArgs = {
  input?: InputMaybe<ReportInput>;
};


export type RootReportsAvailableArgs = {
  input: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type RootRfidKeysArgs = {
  input: GetRfidKeysInput;
};


export type RootSetInvoiceReferenceArgs = {
  input: SetInvoiceReferenceInput;
};


export type RootUpdateChargeSystemArgs = {
  input: ChargeSystemUpdateInput;
};


export type RootUpdateConnectorsAvailabilityArgs = {
  input: ConnectorsAvailabilityInput;
};


export type RootUpsertOrganizationArgs = {
  input: OrganizationUpsertInput;
};

export type SetImdKwhPriceInput = {
  price: Scalars['Float']['input'];
};

export type SetInvoiceReferenceInput = {
  chargeSystemId: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type SetUseImdInput = {
  useImd: Scalars['Boolean']['input'];
};

export type Status = {
  __typename?: 'Status';
  status: Scalars['Boolean']['output'];
};

export type StatusObject = {
  __typename?: 'StatusObject';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorInfo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timeStamp?: Maybe<Scalars['String']['output']>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<StripeAccountSeverity>;
  status?: Maybe<StripeAccountStatus>;
};

export enum StripeAccountSeverity {
  ActionRequired = 'ACTION_REQUIRED',
  Disabled = 'DISABLED',
  None = 'NONE'
}

export enum StripeAccountStatus {
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE',
  Na = 'NA'
}

export enum StripeStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type Subscription = {
  __typename?: 'Subscription';
  billingPeriod?: Maybe<BillingPeriod>;
  endDate?: Maybe<Scalars['String']['output']>;
  nextInvoiceDate?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  subscriptionLines?: Maybe<Array<SubscriptionLine>>;
};

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice';
  cost: Scalars['Float']['output'];
  costInclVat?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  dueDate: Scalars['String']['output'];
  endPeriodDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['String']['output'];
  products: Array<SubscriptionInvoiceProduct>;
  startPeriodDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SubscriptionInvoiceProduct = {
  __typename?: 'SubscriptionInvoiceProduct';
  product: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

export type SubscriptionInvoicesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  paginationToken?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionInvoicesPayload = {
  __typename?: 'SubscriptionInvoicesPayload';
  invoices: Array<SubscriptionInvoice>;
  paginationToken?: Maybe<Scalars['String']['output']>;
  totalNumberOfInvoices: Scalars['Int']['output'];
};

export type SubscriptionLine = {
  __typename?: 'SubscriptionLine';
  activeConnectors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paidConnectors?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<SubscriptionProduct>;
};

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  baseSubscriptionProduct?: Maybe<Scalars['Boolean']['output']>;
  productCategory: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  productPrice: SubscriptionProductPrice;
};

export type SubscriptionProductPrice = {
  __typename?: 'SubscriptionProductPrice';
  billingPeriod: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceInclVAT: Scalars['Float']['output'];
  productPriceId: Scalars['ID']['output'];
  validFrom: Scalars['String']['output'];
  validTo?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT'
}

export type Tariff = LinearTariff | ProgressiveTariff | TimezonedTariff;

export type TariffInput = {
  LinearTariff?: InputMaybe<LinearTariffInput>;
  ProgressiveTariff?: InputMaybe<ProgressiveTariffInput>;
  TimezonedTariff?: InputMaybe<TimezonedTariffInput>;
  type?: InputMaybe<TariffType>;
};

export enum TariffType {
  LinearTariff = 'LinearTariff',
  ProgressiveTariff = 'ProgressiveTariff',
  TimezonedTariff = 'TimezonedTariff'
}

export type TimezonedTariff = {
  __typename?: 'TimezonedTariff';
  fixedCost?: Maybe<Scalars['String']['output']>;
  hourDivisor?: Maybe<Scalars['String']['output']>;
  pricePerHour?: Maybe<Scalars['String']['output']>;
  pricePerHourZone?: Maybe<Scalars['String']['output']>;
  pricePerKwh?: Maybe<Scalars['String']['output']>;
  pricePerKwhZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TariffType>;
  zoneHrEnd?: Maybe<Scalars['String']['output']>;
  zoneHrStart?: Maybe<Scalars['String']['output']>;
};

export type TimezonedTariffInput = {
  fixedCost?: InputMaybe<Scalars['String']['input']>;
  hourDivisor?: InputMaybe<Scalars['String']['input']>;
  pricePerHour?: InputMaybe<Scalars['String']['input']>;
  pricePerHourZone?: InputMaybe<Scalars['String']['input']>;
  pricePerKwh?: InputMaybe<Scalars['String']['input']>;
  pricePerKwhZone?: InputMaybe<Scalars['String']['input']>;
  zoneHrEnd?: InputMaybe<Scalars['String']['input']>;
  zoneHrStart?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleConsumptionInput = {
  consumptionEnabled: Scalars['Boolean']['input'];
};

export type ToggleConsumptionPayload = {
  __typename?: 'ToggleConsumptionPayload';
  status: Scalars['Boolean']['output'];
};

export enum Type {
  Business = 'BUSINESS',
  Private = 'PRIVATE'
}

export type UnitAmount = {
  __typename?: 'UnitAmount';
  amount: Scalars['Float']['output'];
  interval?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type UpdateAdminInput = {
  acceptedPrivacyConditions?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRfidKeyInput = {
  chargeSystems: Array<InputMaybe<Scalars['String']['input']>>;
  connectors: Array<InputMaybe<Scalars['String']['input']>>;
  groups: Array<InputMaybe<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};

export type User = {
  __typename?: 'User';
  activeGroupInvoice?: Maybe<Scalars['Boolean']['output']>;
  chargeSystems: Array<Maybe<UserAccess>>;
  connectors: Array<Maybe<UserAccess>>;
  discount?: Maybe<Scalars['Int']['output']>;
  groups: Array<Maybe<UserAccess>>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  update: User;
};


export type UserUpdateArgs = {
  input: UserUpdateInput;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  accessLevel: UserAccessLevel;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserAccessInput = {
  accessLevel: UserAccessLevel;
  id: Scalars['ID']['input'];
};

export enum UserAccessLevel {
  Owner = 'OWNER',
  User = 'USER'
}

export type UserAlterAccessInput = {
  chargeSystems: Array<InputMaybe<UserAccessInput>>;
  connectors: Array<InputMaybe<UserAccessInput>>;
  groups: Array<InputMaybe<UserAccessInput>>;
  id: Scalars['ID']['input'];
};

export type UserDiscountInput = {
  discount: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type UserInput = {
  connectors?: InputMaybe<Array<InputMaybe<UserAccessInput>>>;
  groups?: InputMaybe<Array<InputMaybe<UserAccessInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type UserInvite = {
  __typename?: 'UserInvite';
  chargeSystems: Array<Maybe<UserAccess>>;
  connectors: Array<Maybe<UserAccess>>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  groups: Array<Maybe<UserAccess>>;
  phoneNumber: Scalars['String']['output'];
};

export type UserInviteInput = {
  chargeSystems: Array<InputMaybe<UserAccessInput>>;
  connectors: Array<InputMaybe<UserAccessInput>>;
  groups: Array<InputMaybe<UserAccessInput>>;
  phoneNumber: Scalars['String']['input'];
};

export type UserPaymentTypeInput = {
  useInvoicing: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type UserUpdateInput = {
  chargeSystems?: InputMaybe<Array<InputMaybe<UserAccessInput>>>;
  connectors?: InputMaybe<Array<InputMaybe<UserAccessInput>>>;
  groups?: InputMaybe<Array<InputMaybe<UserAccessInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type UserUsage = {
  __typename?: 'UserUsage';
  chargingSessions: UnitAmount;
  energyConsumption: UnitAmount;
  invoiceReference?: Maybe<Scalars['String']['output']>;
  occupiedTime: UnitAmount;
  phone: Scalars['String']['output'];
  revenue: UnitAmount;
  user: Scalars['String']['output'];
};

export type VisitorRfidUsage = {
  __typename?: 'VisitorRfidUsage';
  chargingSessions: UnitAmount;
  description: Scalars['String']['output'];
  energyConsumption: UnitAmount;
  keyId: Scalars['String']['output'];
  occupiedTime: UnitAmount;
  revenue: UnitAmount;
};
